<template>
  <div class="section-gap twitch splash-left">
    <div class="container splash-right">
      <div class="section-title-wrapper">
        <div class="fullscreen-row">
          <div
            class="col-sm-12 mx-auto splash-container splash-s d-flex extra-p"
          >
            <h1 class="h1-larger">LIVE STREAM</h1>
          </div>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col text-center">
          <div class="embed-responsive embed-responsive-16by9">
            <div id="twitch-embed"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Twitch",
  data() {
    return {
    };
  },
  methods: {
    loadTwitchPlayer(){
      var embed = new Twitch.Embed("twitch-embed", {
        width: 854,
        height: 480,
        channel: "Mario_Viska",
        layout: "video",
        autoplay: false,
        muted: false,
        // only needed if your site is also embedded on embed.example.com and othersite.example.com 
        parent: ["www.esport-soccercup.at", "esport-soccercup.at"]
      });

      embed.addEventListener(Twitch.Embed.VIDEO_READY, () => {
        var player = embed.getPlayer();
        player.pause();
      });
    }
  },
  components: {},
  mounted(){
    this.loadTwitchPlayer()
  }
};
</script>
<style scoped>
.twitch {
  background-color: black;
}

.extra-p {
  padding-bottom: 50px;
}

.splash-s {
  background-image: url(/static/img/splash_qualifier_red.png);
  background-position: 60% 0%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 110px;
}

.splash-left {
  background-image: url(/static/img/splash-info-left.png);
  background-position: 5% 55%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 150px;
}

.splash-right {
  background-image: url(/static/img/splash-info-right.png);
  background-position: 90% 90%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 110px;
}

.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 760px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 70% 30%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }

  .splash-left {
    background-image: url(/static/img/splash-info-left.png);
    background-position: 0% 30%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }

  .splash-right {
    background-image: url(/static/img/splash-info-right.png);
    background-position: 90% 88%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }
}

@media screen and (min-width: 761px) and (max-width: 1000px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 62% 20%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
  .splash-left {
    background-image: url(/static/img/splash-info-left.png);
    background-position: 10% 35%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }

  .splash-right {
    background-image: url(/static/img/splash-info-right.png);
    background-position: 90% 99%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }
}
</style>